import { AppsURL } from 'shared/constants/AppEnums';
const isProd = process.env.REACT_APP_IS_PROD || '0';

const routesConfigProd = [
  {
    id: 'main',
    title: 'Halaman Utama',
    messageId: 'Halaman Utama',
    type: 'group',
    children: [
      {
        id: 'main-kkp',
        title: 'KKP',
        messageId: 'KKP',
        type: 'item',
        icon: 'Home',
        url: '/kkp',
      },
      {
        id: 'main-satker',
        title: 'Satuan Kerja',
        messageId: 'Satker',
        type: 'item',
        icon: 'Villa',
        url: '/satker',
      },
    ],
  },
  {
    id: 'new-dashboard',
    title: 'Dashboard & Report',
    messageId: 'Dashboard & Report',
    type: 'group',
    // icon: <Dashboard sx={{ fontSize: '20px' }} />,
    role_access: ['D_KK', 'D_KP', 'LPMUKP_DASHBOARD'],
    children: [
      {
        id: 'dashbor-keukin',
        title: 'Keuangan & Kinerja',
        messageId: 'Keuangan & Kinerja',
        type: 'item',
        icon: 'GridView',
        url: '/new-dash/tab/perencanaan',
        role_access: ['D_KK'],
      },
      {
        id: 'dashbor-lpmukp',
        title: 'LPMUKP',
        messageId: 'LPMUKP',
        type: 'item',
        icon: 'GridView',
        url: '/new-dash/lpmukp',
        role_access: ['LPMUKP_DASHBOARD'],
      },
      // {
      //   id: 'dashbor-kepegawaian',
      //   title: 'Kepegawaian',
      //   messageId: 'Kepegawaian',
      //   type: 'item',
      //   icon: 'GridView',
      //   url: '/new-dash/tab/kepegawaian',
      //   role_access: ['D_KP'],
      // },
      {
        id: 'dashbor-kusuka',
        title: 'KUSUKA',
        messageId: 'KUSUKA',
        type: 'item',
        icon: 'GridView',
        url: '/new-dash/tab/kusuka',
        role_access: ['D_KP', 'D_BPEM'],
      },
      {
        id: 'dashbor-produksibudidaya',
        title: 'Produksi Budi Daya',
        messageId: 'Produksi Budi Daya',
        type: 'item',
        icon: 'GridView',
        url: '/new-dash/tab/prodbud',
        role_access: [],
        // role_access: ['D_BD'],
      },
      {
        id: 'dashbor-produksipenangkapan',
        title: 'Produksi Penangkapan',
        messageId: 'Produksi Penangkapan Ikan',
        type: 'item',
        icon: 'GridView',
        url: '/new-dash/tab/prodpen',
        role_access: [],
        // role_access: ['D_PK'],
      },
    ],
  },
  {
    id: 'app-kebijakan',
    title: 'Regulasi',
    messageId: 'Regulasi',
    type: 'nonGroup',
    icon: 'Villa',
    url: '/kebijakan',
  },
  {
    id: 'app',
    title: 'Application',
    messageId: 'Aplikasi',
    type: 'group',
    // role_access: [],
    children: [
      {
        id: 'app-crsfe',
        title: 'Korespondensi',
        messageId: 'Korespondensi',
        type: 'item',
        isNewWindow: '1',
        icon: 'InsertDriveFile',
        url: AppsURL['1'],
        // role_access: []
      },
      {
        id: 'app-sispeg',
        title: 'Portal Pegawai',
        messageId: 'Portal Pegawai',
        type: 'item',
        isNewWindow: '1',
        icon: 'LocalLibrary',
        url: AppsURL['17'],
        // role_access: ['SIPEG.AKSES']
      },
      {
        id: 'app-arsip',
        title: 'Arsiparis',
        messageId: 'Arsiparis',
        type: 'item',
        isNewWindow: '1',
        icon: 'Archive',
        url: AppsURL['16'],
        role_access: ['ARSIPARIS.USER'],
      },
      {
        id: 'app-email',
        title: 'Email',
        messageId: 'Email',
        type: 'item',
        isNewWindow: '1',
        icon: 'Email',
        url: AppsURL['2'],
      },
      // {
      //   id: 'app-kebijakan',
      //   title: 'Kebijakan',
      //   messageId: 'Kebijakan',
      //   type: 'item',
      //   icon: 'Villa',
      //   url: '/kebijakan',
      //   // role_access: []
      // },
      {
        id: 'app-preshare',
        title: 'KKP Drive',
        messageId: 'KKP Drive',
        type: 'item',
        icon: 'Storage',
        url: '/apps/drive',
        role_access: ['PRESHARE.USER'],
        // permitted_role: ['pegawai']
      },
      {
        id: 'app-bpk-drive-internal',
        title: 'BPK Drive',
        messageId: 'BPK Drive',
        type: 'item',
        icon: 'ReceiptLong',
        url: '/apps/bpk-drive',
        role_access: ['BPK_DRIVE_INTERNAL_ESELON_1', 'BPK_DRIVE_INTERNAL_ESELON_2'],
      },
      {
        id: 'digital-sign',
        title: 'Digital Sign',
        messageId: 'Digital Sign',
        type: 'collapse',
        icon: 'Create',
        children: [
          {
            id: 'digital-sign-dokumen',
            title: 'Dokumen Lain',
            messageId: 'Dokumen Lain',
            type: 'item',
            icon: 'Create',
            url: '/apps/dokumen-lain',
          },
          {
            id: 'digital-sign-dokumen-sk',
            title: 'Dokumen Surat Keputusan',
            messageId: 'Dokumen Surat Keputusan',
            type: 'item',
            icon: 'Create',
            url: '/apps/dokumen-sk',
          },
          {
            id: 'digital-sign-dokumen-pk',
            title: 'Dokumen PK PPPK',
            messageId: 'Dokumen PK PPPK',
            type: 'item',
            icon: 'Create',
            url: '/apps/dokumen-pk',
          },
          {
            id: 'digital-sign-siap-mutu',
            title: 'SiapMutu',
            messageId: 'SiapMutu',
            type: 'item',
            icon: 'Create',
            url: '/apps/siap-mutu',
            role_access: ['SIAP_MUTU', 'MONITORING_DIGITAL_SIGN', 'OPERATOR_SIAP_MUTU', 'APPROVERS.DIGISIGN.SIAPMUTU'],
          },
          {
            id: 'dashboard-dokumen',
            title: 'Dashboard Dokumen',
            messageId: 'Dashboard Monitoring',
            type: 'item',
            icon: 'Create',
            url: '/apps/dashboard-dokumen',
            role_access: ['MONITORING_DIGITAL_SIGN']
          },
          {
            id: 'digital-sign-verify',
            title: 'Verifikasi',
            messageId: 'Verifikasi',
            type: 'item',
            isNewWindow: '1',
            icon: 'Create',
            url: AppsURL['14'],
          },
        ],
      },
      {
        id: 'app-empsrv',
        title: 'Layanan Mandiri',
        messageId: 'Layanan Mandiri',
        type: 'collapse',
        icon: 'Person',
        children: [
          {
            id: 'app-cuti',
            title: 'Cuti',
            messageId: 'Cuti',
            type: 'item',
            isNewWindow: '1',
            icon: 'TimeToLeaveOutlined',
            url: AppsURL['8'],
          },
          {
            id: 'app-sppd',
            title: 'SPPD',
            messageId: 'SPPD',
            type: 'item',
            isNewWindow: '1',
            icon: 'AirplaneTicketOutlined',
            url: AppsURL['10'],
          },
        ],
      },
      {
        id: 'app-agenda',
        title: 'Agenda / Kalender',
        messageId: 'Agenda / Kalender',
        type: 'collapse',
        icon: 'CalendarMonth',
        // role_access: ['TASK.USER'],
        children: [
          {
            id: 'app-agenda-gc',
            title: 'Agenda',
            messageId: 'Agenda',
            type: 'item',
            icon: 'CalendarMonth',
            url: '/apps/GroupCalendar',
            role_access: ['CALENDAR.USER'],
          },
          {
            id: 'app-agenda-kalender',
            title: 'Kalender Personal',
            messageId: 'Kalender Personal',
            type: 'item',
            icon: 'CalendarMonth',
            url: '/apps/kalender-personal',
          },
          {
            id: 'app-agenda-kalender-satker',
            title: 'Kalender Satker',
            messageId: 'Kalender Satker',
            type: 'item',
            icon: 'CalendarMonth',
            url: '/apps/kalender-satker',
            role_access: ['CALENDAR_SATKER']
          },
        ],
      },
      // {
      //   id: 'app-kepegawaian',
      //   title: 'Kepegawaian',
      //   messageId: 'Kepegawaian',
      //   type: 'collapse',
      //   icon: 'LocalLibrary',
      //   children: [
      //     {
      //       id: 'app-kepegawaian-ipasn',
      //       title: 'IPASN',
      //       messageId: 'IPASN',
      //       type: 'item',
      //       icon: 'LocalLibrary',
      //       url: '/apps/kepegawaian/ipasn',
      //     },
      //     {
      //       id: 'app-kepegawaian-pegawai',
      //       title: 'Pegawai',
      //       messageId: 'Pegawai',
      //       type: 'item',
      //       icon: 'LocalLibrary',
      //       url: '/apps/kepegawaian/karyawan',
      //     },
      //     {
      //       id: 'app-kepegawaian-nominatif-pegawai',
      //       title: 'Nominatif Pegawai',
      //       messageId: 'Nominatif Pegawai',
      //       type: 'item',
      //       icon: 'LocalLibrary',
      //       url: '/apps/kepegawaian/nominatif-pegawai',
      //     },
      //     {
      //       id: 'app-sispeg',
      //       title: 'Portal Pegawai',
      //       messageId: 'Portal Pegawai',
      //       type: 'item',
      //       isNewWindow: '1',
      //       icon: 'LocalLibrary',
      //       url: AppsURL['17'],
      //       // role_access: ['SIPEG.AKSES']
      //     },
      //   ],
      // },
      // {
      //   id: 'app-gc',
      //   title: 'Kalender',
      //   messageId: 'Kalender',
      //   type: 'item',
      //   icon: 'CalendarMonth',
      //   url: '/apps/GroupCalendar',
      //   role_access: ['CALENDAR.USER'],
      // },
      // {
      //   id: 'app-kalender-personal',
      //   title: 'Kalender Personal',
      //   messageId: 'Kalender Personal',
      //   type: 'item',
      //   icon: 'CalendarMonth',
      //   url: '/apps/kalender-personal',
      // },
      {
        id: 'app-event',
        title: 'Event Management',
        messageId: 'Event Management',
        type: 'item',
        isIframe: '1',
        icon: 'EventAvailable',
        url: '/apps/event',
        role_access: ['EVENT.USER'],
      },
      {
        id: 'app-task',
        title: 'Task Management',
        messageId: 'Task Management',
        type: 'collapse',
        icon: 'TaskAlt',
        // role_access: ['TASK.USER'],
        children: [
          {
            id: 'main-app-task',
            title: 'Main',
            messageId: 'Main',
            type: 'item',
            icon: 'TaskAlt',
            url: '/apps/taskmanagement',
          },
          {
            id: 'app-task-rangkuman',
            title: 'Laporan',
            messageId: 'Laporan',
            type: 'item',
            icon: 'TaskAlt',
            url: '/dash/tab/taskmanagement',
          },
        ],
      },
      {
        id: 'app-repository',
        title: 'Repositori',
        messageId: 'Repositori',
        type: 'item',
        isNewWindow: '1',
        icon: 'DriveFileMove',
        url: AppsURL['13'],
        // role_access: [],
      },
      {
        id: 'app-rtc',
        title: 'Real Time Collaboration',
        messageId: 'Real Time Collaboration',
        type: 'collapse',
        icon: 'Groups',
        // role_access: [],
        children: [
          {
            id: 'chat',
            title: 'Chat',
            messageId: 'Chat',
            type: 'item',
            isNewWindow: '1',
            icon: 'Groups',
            url: AppsURL['11'],
            // role_access: [],
          },
          {
            id: 'app-videconf',
            title: 'Video Conference',
            messageId: 'Video Conference',
            type: 'item',
            isNewWindow: '1',
            icon: 'VideoCall',
            url: AppsURL['9'],
            // role_access: [],
          },
        ],
      },
      {
        id: 'app-helpdesk',
        title: 'Help Desk',
        messageId: 'Help Desk',
        type: 'item',
        isNewWindow: '1',
        icon: 'HelpCenter',
        url: AppsURL['12'],
      },
    ],
  },
  {
    id: 'app-bankom',
    title: 'Pengembangan Kompetensi',
    messageId: 'Pengembangan Kompetensi',
    type: 'group',
    children: [
      {
        id: 'mp',
        title: 'Manajemen Pengetahuan',
        messageId: 'Pengetahuan',
        type: 'collapse',
        icon: 'School',
        children: [
          {
            id: 'mp-linimasa',
            title: 'Manajemen Pengetahuan',
            messageId: 'Lini Masa',
            type: 'item',
            isIframe: '1',
            icon: 'School',
            url: '/apps/KnowledgeManagement',
          },
          {
            id: 'mp-postingan_saya',
            title: 'Postingan Saya',
            messageId: 'Postingan Saya',
            type: 'item',
            icon: 'School',
            url: '/apps/mypost',
          },
          {
            id: 'mp-admin-dashrangiku',
            title: 'Rangkuman IKU',
            messageId: 'Rangkuman IKU',
            type: 'item',
            icon: 'School',
            url: '/new-dash/tab/rangkuman-iku',
            role_access: [
              'MP.PNL',
              'PNL.SES.BKIPMKHP',
              'PNL.SES.BRSDM',
              'PNL.SES.DJPB',
              'PNL.SES.DJPDSPKP',
              'PNL.SES.DJPRL',
              'PNL.SES.DJPSDKP',
              'PNL.SES.DJPT',
              'PNL.SES.IJ',
              'PNL.SES.PSD',
              'PNL.SES.SEKJEN',
            ],
          },
          {
            id: 'mp-admin-laporan',
            title: 'Laporan',
            messageId: 'Laporan',
            type: 'item',
            icon: 'School',
            url: '/apps/adminkm-laporan',
            role_access: [
              'MP.PNL',
              'PNL.SES.BKIPMKHP',
              'PNL.SES.BRSDM',
              'PNL.SES.DJPB',
              'PNL.SES.DJPDSPKP',
              'PNL.SES.DJPRL',
              'PNL.SES.DJPSDKP',
              'PNL.SES.DJPT',
              'PNL.SES.IJ',
              'PNL.SES.PSD',
              'PNL.SES.SEKJEN',
            ],
          },
          {
            id: 'mp-admin-penilaian',
            title: 'Penilaian',
            messageId: 'Penilaian',
            type: 'item',
            icon: 'School',
            url: '/apps/adminkm-penilaian',
            role_access: [
              'MP.PNL',
              'PNL.SES.BKIPMKHP',
              'PNL.SES.BRSDM',
              'PNL.SES.DJPB',
              'PNL.SES.DJPDSPKP',
              'PNL.SES.DJPRL',
              'PNL.SES.DJPSDKP',
              'PNL.SES.DJPT',
              'PNL.SES.IJ',
              'PNL.SES.PSD',
              'PNL.SES.SEKJEN',
            ],
          },
          // {
          //   id: 'mp-admin-kategori',
          //   title: 'Kategori',
          //   messageId: 'Kategori',
          //   type: 'item',
          //   icon: 'School',
          //   url: '/apps/adminkm-kategori',
          // },
          // {
          //   id: 'mp-admin-kompetensi',
          //   title: 'Kompetensi',
          //   messageId: 'Kompetensi',
          //   type: 'item',
          //   icon: 'School',
          //   url: '/apps/adminkm-kompetensi',
          // },
        ],
      },
      {
        id: 'app-aksi-perubahan',
        title: 'Aksi Perubahan',
        messageId: 'Aksi Perubahan',
        type: 'item',
        icon: 'PublishedWithChanges',
        url: '/apps/information/aksi-perubahan',
      },
      {
        id: 'app-sertifikat',
        title: 'Sertifikat',
        messageId: 'Sertifikat',
        type: 'collapse',
        icon: 'Villa',
        children: [
          {
            id: 'app-sertifikat-lms',
            title: 'Sertifikat LMS',
            messageId: 'Sertifikat LMS',
            type: 'item',
            icon: 'Villa',
            url: '/apps/sertifikat-lms',
          },
          {
            id: 'app-sertifikat-ttde',
            title: 'Sertifikat TTDE',
            messageId: 'Sertifikat TTDE',
            type: 'item',
            icon: 'Villa',
            url: '/apps/sertifikat-ttde',
          },
          {
            id: 'app-sertifikat-eksternal',
            title: 'Sertifikat Eksternal',
            messageId: 'Sertifikat Eksternal',
            type: 'item',
            icon: 'Villa',
            url: '/apps/sertifikat-eksternal',
          },
        ],
      },
      {
        id: 'app-bankom-laporan',
        title: 'Laporan',
        messageId: 'Laporan',
        type: 'item',
        icon: 'Create',
        url: '/apps/laporan-bankom',
        role_access: ['LAPORAN_BSRE', 'MONITORING_DIGITAL_SIGN'],
      },
      {
        id: 'app-elearning',
        title: 'e-Learning',
        messageId: 'e-Learning',
        type: 'item',
        isNewWindow: '1',
        icon: 'LocalLibrary',
        url: AppsURL['15'],
      },
      // {
      //   id: 'info-modal',
      //   title: 'Info',
      //   messageId: 'Info',
      //   type: 'modal',
      //   icon: 'InfoOutlined'
      // }
    ]
  },
  {
    id: 'app-perizinan-menteri',
    title: 'Perizinan Menteri',
    messageId: 'Perizinan Menteri',
    type: 'nonGroup',
    icon: 'Gesture',
    url: '/apps/perizinan-menteri/pkrl',
    role_access: ['PERIZINAN_MENTERI', 'MONITORING_DIGITAL_SIGN'],
  },
  {
    id: 'app-sertifikat-menteri',
    title: 'Sertifikat Menteri',
    messageId: 'Sertifikat Menteri',
    type: 'nonGroup',
    icon: 'WorkspacePremium',
    url: '/apps/sertifikat-menteri',
    role_access: ['SERTIFIKAT_MENTERI', 'MONITORING_DIGITAL_SIGN'],
  },
  {
    id: 'app-produk-hukum',
    title: 'Produk Hukum',
    messageId: 'Produk Hukum',
    type: 'group',
    role_access: ['UPLOAD.PRODUK.HUKUM', 'UPLOAD.PRODUK.HUKUM.DIRJEN', 'OPERATOR.NOMOR.PRODUK.HUKUM', 'MONITORING_DIGITAL_SIGN', 'APPROVERS.PRODUK.HUKUM.DIRJEN'],
    children: [
      {
        id: 'app-produk-hukum-biro-hukum',
        title: 'Produk Hukum Biro Hukum',
        messageId: 'Produk Hukum Biro Hukum',
        type: 'item',
        icon: 'AssignmentTurnedIn',
        url: '/apps/produk-hukum',
        role_access: ['UPLOAD.PRODUK.HUKUM', 'OPERATOR.NOMOR.PRODUK.HUKUM', 'MONITORING_DIGITAL_SIGN'],
      },
      {
        id: 'app-produk-hukum-dirjen',
        title: 'Produk Hukum Dirjen',
        messageId: 'Produk Hukum Dirjen',
        type: 'item',
        icon: 'AssignmentTurnedIn',
        url: '/apps/produk-hukum-dirjen',
        role_access: ['UPLOAD.PRODUK.HUKUM.DIRJEN', 'MONITORING_DIGITAL_SIGN', 'APPROVERS.PRODUK.HUKUM.DIRJEN'],
      },
    ]
  },
  {
    id: 'produk-lpmukp',
    title: 'Produk LPMUKP',
    messageId: 'Produk LPMUKP',
    type: 'nonGroup',
    icon: 'Assignment',
    url: '/produk-lpmukp',
    role_access: ['PRODUK.LPMUKP'],
  },
  {
    id: 'admtls',
    title: 'Admintools',
    messageId: 'Admin Tools',
    role_access: ['ADMIN_TOOLS'],
    type: 'group',
    children: [
      {
        id: 'admtls-profile',
        title: 'Profile',
        messageId: 'Profile',
        type: 'collapse',
        icon: 'SupervisorAccount',
        role_access: ['ADMIN_TOOLS'],
        children: [
          {
            id: 'admtls-pegawai',
            title: 'Pegawai',
            messageId: 'Pegawai',
            type: 'item',
            icon: 'SupervisorAccount',
            url: '/apps/admintools/employee',
          },
          {
            id: 'admtls-jabatan',
            title: 'Jabatan',
            messageId: 'Jabatan',
            type: 'item',
            icon: 'SupervisorAccount',
            url: '/apps/admintools/title',
          },
          {
            id: 'admtls-struktur-organisasi',
            title: 'Struktur Organisasi',
            messageId: 'Struktur Organisasi',
            type: 'item',
            icon: 'SupervisorAccount',
            url: '/apps/admintools/division',
          },
          // {
          //   id: 'admtls-faq',
          //   title: 'FAQ',
          //   messageId: 'FAQ',
          //   type: 'item',
          //   icon: <SupervisorAccount />,

          //   url: '/apps/admintools/faq',
          // },
          {
            id: 'app-userrole',
            title: 'User Role',
            messageId: 'User Role',
            type: 'item',
            icon: 'SupervisorAccount',
            url: '/apps/userrole',
          },
        ],
      },
      {
        id: 'admtls-pengetahuan',
        title: 'Pengetahuan',
        messageId: 'Pengetahuan',
        type: 'collapse',
        icon: 'School',
        role_access: ['ADMIN_TOOLS'],
        children: [
          {
            id: 'admtls-admin-kompetensi',
            title: 'Kompetensi',
            messageId: 'Kompetensi',
            type: 'item',
            icon: 'School',
            url: '/apps/adminkm-kompetensi',
          },
          {
            id: 'admtls-admin-kategori',
            title: 'Kategori',
            messageId: 'Kategori',
            type: 'item',
            icon: 'School',
            url: '/apps/adminkm-kategori',
          },
        ],
      },
      {
        id: 'admtls-crsfe',
        title: 'Korespondensi',
        messageId: 'Korespondensi',
        type: 'collapse',
        icon: 'InsertDriveFile',
        role_access: ['CRSFE_ADMIN_PENOMORAN'],
        children: [
          {
            id: 'admtls-penomoran',
            title: 'Penomoran',
            messageId: 'Penomoran',
            type: 'item',
            icon: 'InsertDriveFile',
            url: '/apps/admintools/penomoran',
            // role_access: []
          },
          {
            id: 'admtls-scan',
            title: 'Input Surat Masuk',
            messageId: 'Input Surat Masuk',
            type: 'item',
            icon: 'InsertDriveFile',
            url: '/apps/admintools/input-scan',
            // role_access: []
          },
          {
            id: 'admtls-inpusurat',
            title: 'Input Surat Keluar',
            messageId: 'Input Surat Keluar',
            type: 'item',
            icon: 'InsertDriveFile',
            url: '/apps/admintools/input-sk',
            // role_access: []
          },
          // {
          //   id: 'admtls-addgroup',
          //   title: 'Group Addressbook',
          //   messageId: 'Group Addressbook',
          //   type: 'item',
          //   icon: 'InsertDriveFile',
          //   url: '/apps/admintools/group-book',
          //   // role_access: []
          // },
          {
            id: 'admtls-operator',
            title: 'Operator',
            messageId: 'Operator',
            type: 'item',
            icon: 'InsertDriveFile',
            url: '/apps/admintools/operator',
            role_access: [],
          },
        ],
      },
      {
        id: 'admtls-masterdata',
        title: 'Master Data',
        messageId: 'Master Data',
        role_access: ['ADMIN_TOOLS'],
        type: 'collapse',
        icon: 'Storage',
        children: [
          // {
          //   id: 'admntls-organisasi',
          //   title: 'Organisasi',
          //   messageId: 'Organisasi',
          //   type: 'item',
          //   icon: 'Storage',
          //   url: '/apps/admintools/organisasi',
          //   // role_access: []
          // },
          {
            id: 'admntls-satker',
            title: 'Unit Kerja',
            messageId: 'Unit Kerja',
            type: 'item',
            icon: 'Storage',
            url: '/apps/admintools/satker',
            // role_access: []
          },
          {
            id: 'admtls-faq',
            title: 'FAQ DATA',
            messageId: 'FAQ DATA',
            type: 'collapse',
            icon: 'Storage',
            children: [
              {
                id: 'admtls-faq',
                title: 'FAQ ',
                messageId: 'FAQ ',
                type: 'item',
                url: '/apps/admintools/faq',
                icon: 'Storage',
              },
              {
                id: 'admtls-faq-module',
                title: 'FAQ MODUL',
                messageId: 'FAQ MODUL ',
                type: 'item',
                url: '/apps/admintools/module',
                icon: 'Storage',
              },
              {
                id: 'admtls-faq-group',
                title: 'FAQ GROUP',
                messageId: 'FAQ GROUP ',
                type: 'item',
                url: '/apps/admintools/group',
                icon: 'Storage',
              },
            ],
          },
          {
            id: 'admntls-unitkerja',
            title: 'Satuan Kerja',
            messageId: 'Satuan Kerja',
            type: 'item',
            icon: 'Storage',
            url: '/apps/admintools/unitkerja',
            // role_access: []
          },
          {
            id: 'admntls-km',
            title: 'Kode Retensi',
            messageId: 'Kode Retensi',
            type: 'item',
            icon: 'Storage',
            url: '/apps/admintools/km',
            // role_access: []
          },
          {
            id: 'admntls-jobs',
            title: 'Jobs',
            messageId: 'Jobs',
            type: 'item',
            icon: 'Storage',
            url: '/apps/admintools/jobs',
            // role_access: []
          },
          {
            id: 'admntls-notatindakan',
            title: 'Nota Tindakan',
            messageId: 'Nota Tindakan',
            type: 'item',
            icon: 'Storage',
            url: '/apps/admintools/notatindakan',
            // role_access: []
          },
          // {
          //   id: 'admtls-faq',
          //   title: 'FAQ',
          //   messageId: 'FAQ',
          //   type: 'item',
          //   icon: 'Storage',
          //   url: '/apps/admintools/faq',
          // },
          // {
          //   id: 'admntls-bidang',
          //   title: 'Bidang',
          //   messageId: 'Bidang',
          //   type: 'item',
          //   icon: 'Storage',
          //   url: '/apps/admintools/bidang',
          //   // role_access: []
          // },
          // {
          //   id: 'admntls-subbidang',
          //   title: 'Sub Bidang',
          //   messageId: 'Sub Bidang',
          //   type: 'item',
          //   icon: 'Storage',
          //   url: '/apps/admintools/subbidang',
          //   // role_access: []
          // },
          // {
          //   id: 'admntls-retensi',
          //   title: 'Kode Retensi',
          //   messageId: 'Kode Retensi',
          //   type: 'item',
          //   icon: 'Storage',
          //   url: '/apps/admintools/retensi',
          //   // role_access: []
          // },
        ],
      },
      {
        id: 'admtls-logs',
        title: 'Logs',
        messageId: 'Logs',
        role_access: ['ADMIN_TOOLS'],
        type: 'collapse',
        icon: 'MonitorHeart',
        children: [
          {
            id: 'admntls-logs',
            title: 'Log Login',
            messageId: 'Log Login',
            type: 'item',
            icon: 'MonitorHeart',
            url: '/apps/admintools/logs',
            role_access: ['ADMIN_TOOLS'],
          },
          {
            id: 'admntls-logs-notification',
            title: 'Log Notification',
            messageId: 'Log Notification',
            type: 'item',
            icon: 'MonitorHeart',
            url: '/apps/admintools/logsnotification',
            role_access: ['ADMIN_TOOLS'],
          },
          {
            id: 'admntls-logs-download',
            title: 'Log Download',
            messageId: 'Log Download',
            type: 'item',
            icon: 'MonitorHeart',
            url: '/apps/admintools/logsheaven',
            role_access: ['ADMIN_TOOLS'],
          },
          {
            id: 'admntls-logs-print',
            title: 'Log Print',
            messageId: 'Log Print',
            type: 'item',
            icon: 'MonitorHeart',
            url: '/apps/admintools/logsprint',
            role_access: ['ADMIN_TOOLS'],
          },
          {
            id: 'admntls-logs-service-digisign',
            title: 'Log Service Digital Sign',
            messageId: 'Log Service Digital Sign',
            type: 'item',
            icon: 'MonitorHeart',
            url: '/apps/admintools/logsservicedigisign',
            role_access: ['ADMIN_TOOLS'],
          },
        ],
      },
      {
        id: 'admntls-template',
        title: 'Template',
        messageId: 'Template',
        type: 'item',
        icon: 'FileCopy',
        url: '/apps/admintools/template',
        role_access: ['ADMIN_TOOLS'],
      },
      // {
      //   id: 'admtls-digisign',
      //   title: 'Tanda Tangan Digital',
      //   messageId: 'Tanda Tangan Digital',
      //   role_access: ['ADMIN_TOOLS'],
      //   type: 'collapse',
      //   icon: <Edit sx={{ fontSize: '20px' }} />,
      //   children: [

      //     {
      //       id: 'admntls-report',
      //       title: 'Report',
      //       messageId: 'Report',
      //       type: 'item',
      //       icon: <Edit sx={{ fontSize: '20px' }} />,
      //       url: '/apps/admintools/detail/report-admtls',
      //       // role_access: []
      //     },

      //     {
      //       id: 'admtls-course',
      //       title: 'Judul Course',
      //       messageId: 'Judul Course',
      //       type: 'item',
      //       icon: <Edit sx={{ fontSize: '20px' }} />,
      //       url: '/apps/admintools/course',
      //       // role_access: []
      //     },
      //     {
      //       id: 'admtls-penandatanganan',
      //       title: 'Penandatanganan Bankom',
      //       messageId: 'Penandatanganan Bankom',
      //       type: 'item',
      //       icon: <Edit sx={{ fontSize: '20px' }} />,
      //       url: '/apps/admintools/signer',
      //       // role_access: []
      //     },
      //     {
      //       id: 'admtls-tipedokumen',
      //       title: 'Tipe Document',
      //       messageId: 'Tipe Document',
      //       type: 'item',
      //       icon: <Edit sx={{ fontSize: '20px' }} />,
      //       url: '/apps/admintools/type-document',
      //       // role_access: []
      //     },

      //   ]
      // },
    ],
  },
  {
    id: 'app-group-cms',
    title: 'CMS',
    messageId: 'CMS',
    type: 'group',
    role_access: ['OP.UNKER.WEB', 'ADMIN.UNKER.WEB', 'ADMIN.WEB', 'PPID.KKP', 'PPID.P.PUSAT', 'PPID.P.TEKNIS', 'WEB.UKPBJ', 'WEB.ROPEG'],
    children: [
      {
        id: 'app-cms',
        title: 'CMS_Website',
        messageId: 'Website',
        type: 'item',
        isNewWindow: '1',
        icon: 'Language',
        url: 'http://192.168.13.52:30003/oidc/authenticate',
        role_access: ['OP.UNKER.WEB', 'ADMIN.UNKER.WEB', 'ADMIN.WEB'],
      },
      {
        id: 'app-ppid',
        title: 'CMS_PPID',
        messageId: 'PPID',
        type: 'item',
        isNewWindow: '1',
        icon: 'Language',
        url: 'http://192.168.13.83:30011/manage/oidc/authenticate/',
        role_access: ['PPID.KKP', 'PPID.P.PUSAT', 'PPID.P.TEKNIS'],
      },
      {
        id: 'app-ukpbj',
        title: 'CMS_UKPBJ',
        messageId: 'UKPBJ',
        type: 'item',
        isNewWindow: '1',
        icon: 'Language',
        url: 'http://192.168.13.52:30004/oidc/authenticate/',
        role_access: ['WEB.UKPBJ'],
      },
      {
        id: 'app-sdmao',
        title: 'CMS_SDMAO',
        messageId: 'SDMAO',
        type: 'item',
        isNewWindow: '1',
        icon: 'Language',
        url: 'http://192.168.13.83:30013/back-office/oidc/authenticate/',
        role_access: ['WEB.ROPEG'],
      },
    ]
  },
  {
    id: 'app-survey',
    title: 'Survei',
    messageId: 'Survei Layanan',
    type: 'nonGroup',
    icon: 'DriveFileRenameOutline',
    url: '/survey',
  },
];

const routesConfigDev = [
  {
    id: 'main',
    title: 'Halaman Utama',
    messageId: 'Halaman Utama',
    // icon: 'Home',
    type: 'group',
    permitted_role: ['honorer'],
    children: [
      {
        id: 'main-kkp',
        title: 'KKP',
        messageId: 'KKP',
        type: 'item',
        icon: 'Home',
        url: '/kkp',
      },
      {
        id: 'main-satker',
        title: 'Satuan Kerja',
        messageId: 'Satker',
        type: 'item',
        icon: 'Villa',
        url: '/satker',
      },
      {
        id: 'pegawai',
        title: 'Pegawai',
        messageId: 'Pegawai',
        type: 'item',
        icon: 'Person',
        url: '/pegawai',
      },
    ],
  },
  {
    id: 'new-dashboard',
    title: 'Dashboard & Report',
    messageId: 'Dashboard & Report',
    type: 'group',
    // icon: <Dashboard sx={{ fontSize: '20px' }} />,
    // role_access: ['D_KK', 'D_KP', 'D_BD', 'D_PK', 'LPMUKP_DASHBOARD'],
    role_access: ['D_KK', 'D_KP', 'LPMUKP_DASHBOARD'],
    children: [
      {
        id: 'dashbor-keukin',
        title: 'Keuangan & Kinerja',
        messageId: 'Keuangan & Kinerja',
        type: 'item',
        icon: 'GridView',
        url: '/new-dash/tab/perencanaan',
        role_access: ['D_KK'],
      }, {
        id: 'dashbor-lpmukp',
        title: 'LPMUKP',
        messageId: 'LPMUKP',
        type: 'item',
        icon: 'GridView',
        url: '/new-dash/lpmukp',
        role_access: ['LPMUKP_DASHBOARD'],
      },
      {
        id: 'dashbor-kepegawaian',
        title: 'Kepegawaian',
        messageId: 'Kepegawaian',
        type: 'item',
        icon: 'GridView',
        url: '/new-dash/tab/kepegawaian',
        role_access: ['D_KP'],
      },
      {
        id: 'dashbor-kusuka',
        title: 'KUSUKA',
        messageId: 'KUSUKA',
        type: 'item',
        icon: 'GridView',
        url: '/new-dash/tab/kusuka',
        role_access: ['D_KP', 'D_BPEM'],
      },
      {
        id: 'dashbor-produksibudidaya',
        title: 'Produksi Budi Daya',
        messageId: 'Produksi Budi Daya',
        type: 'item',
        icon: 'GridView',
        url: '/new-dash/tab/prodbud',
        role_access: [],
        // role_access: ['D_BD'],
      },
      {
        id: 'dashbor-produksipenangkapan',
        title: 'Produksi Penangkapan',
        messageId: 'Produksi Penangkapan Ikan',
        type: 'item',
        icon: 'GridView',
        url: '/new-dash/tab/prodpen',
        role_access: [],
        // role_access: ['D_PK'],
      },
    ],
  },
  {
    id: 'app-kebijakan',
    title: 'Regulasi',
    messageId: 'Regulasi',
    type: 'nonGroup',
    icon: 'Villa',
    url: '/kebijakan',
  },
  {
    id: 'app',
    title: 'Application',
    messageId: 'Aplikasi',
    // permitted_role: [],
    // icon: <Apps sx={{ fontSize: '20px' }} />,
    type: 'group',
    children: [
      {
        id: 'app-crsfe',
        title: 'Korespondensi',
        messageId: 'Korespondensi',
        type: 'item',
        isNewWindow: '1',
        icon: 'InsertDriveFile',
        url: AppsURL['1'],
      },
      {
        id: 'app-sispeg',
        title: 'SIPEG',
        messageId: 'SIPEG',
        type: 'item',
        isNewWindow: '1',
        icon: 'LocalLibrary',
        url: AppsURL['17'],
        role_access: ['A0001']
      },
      {
        id: 'app-arsip',
        title: 'Arsiparis',
        messageId: 'Arsiparis',
        type: 'item',
        isNewWindow: '1',
        icon: 'Archive',
        url: AppsURL['16'],
        role_access: ['ARSIPARIS.USER'],
      },
      {
        id: 'app-email',
        title: 'Email',
        messageId: 'Email',
        type: 'item',
        isNewWindow: '1',
        icon: 'Email',
        url: AppsURL['2'],
        // role_access: [],
      },
      // {
      //   id: 'app-kebijakan',
      //   title: 'Kebijakan',
      //   messageId: 'Kebijakan',
      //   type: 'item',
      //   icon: 'Villa',
      //   url: '/kebijakan',
      // },
      {
        id: 'app-preshare',
        title: 'KKP Drive',
        messageId: 'KKP Drive',
        type: 'item',
        icon: 'Storage',
        url: '/apps/drive',
        role_access: ['PRESHARE.USER'],
        // permitted_role: ['pegawai']
      },
      {
        id: 'app-bpk-drive-internal',
        title: 'BPK Drive',
        messageId: 'BPK Drive',
        type: 'item',
        icon: 'ReceiptLong',
        url: '/apps/bpk-drive',
        role_access: ['BPK_DRIVE_INTERNAL_ESELON_1', 'BPK_DRIVE_INTERNAL_ESELON_2'],
      },
      {
        id: 'app-notulensi',
        title: 'Notulensi',
        messageId: 'Notulensi',
        type: 'item',
        icon: 'Gesture',
        url: '/apps/notulensi',
        role_access: ['NOTULENSI_USER'],
        // permitted_role: ['pegawai']
      },
      // {
      //   id: 'app-inforgrafis',
      //   title: 'Infografis',
      //   messageId: 'Infografis',
      //   type: 'item',
      //   icon: 'Storage',
      //   url: '/apps/admintools/infografis',
      //   role_access: []
      // },
      {
        id: 'digital-sign',
        title: 'Digital Sign',
        messageId: 'Digital Sign',
        type: 'collapse',
        icon: 'Create',
        children: [
          {
            id: 'digital-sign-dokumen',
            title: 'Dokumen Lain',
            messageId: 'Dokumen Lain',
            type: 'item',
            icon: 'Create',
            url: '/apps/dokumen-lain',
          },
          {
            id: 'digital-sign-dokumen-sk',
            title: 'Dokumen Surat Keputusan',
            messageId: 'Dokumen Surat Keputusan',
            type: 'item',
            icon: 'Create',
            url: '/apps/dokumen-sk',
          },
          {
            id: 'digital-sign-dokumen-pk',
            title: 'Dokumen PK PPPK',
            messageId: 'Dokumen PK PPPK',
            type: 'item',
            icon: 'Create',
            url: '/apps/dokumen-pk',
          },
          {
            id: 'digital-sign-siap-mutu',
            title: 'SiapMutu',
            messageId: 'SiapMutu',
            type: 'item',
            icon: 'Create',
            url: '/apps/siap-mutu',
            role_access: ['SIAP_MUTU', 'MONITORING_DIGITAL_SIGN', 'OPERATOR_SIAP_MUTU', 'APPROVERS.DIGISIGN.SIAPMUTU'],
          },
          {
            id: 'dashboard-dokumen',
            title: 'Dashboard Dokumen',
            messageId: 'Dashboard Monitoring',
            type: 'item',
            icon: 'Create',
            url: '/apps/dashboard-dokumen',
            role_access: ['MONITORING_DIGITAL_SIGN']
          },
          {
            id: 'digital-sign-verify',
            title: 'Verifikasi',
            messageId: 'Verifikasi',
            type: 'item',
            isNewWindow: '1',
            icon: 'Create',
            url: AppsURL['14'],
          },
        ],
      },
      {
        id: 'app-empsrv',
        title: 'Layanan Mandiri',
        messageId: 'Layanan Mandiri',
        type: 'collapse',
        icon: 'Person',
        children: [
          {
            id: 'app-cuti',
            title: 'Cuti',
            messageId: 'Cuti',
            type: 'item',
            isNewWindow: '1',
            icon: 'TimeToLeaveOutlined',
            url: AppsURL['8'],
          },
          {
            id: 'app-sppd',
            title: 'SPPD',
            messageId: 'SPPD',
            type: 'item',
            isNewWindow: '1',
            icon: 'AirplaneTicketOutlined',
            url: AppsURL['10'],
          },
        ],
      },
      {
        id: 'app-agenda',
        title: 'Agenda / Kalender',
        messageId: 'Agenda / Kalender',
        type: 'collapse',
        icon: 'CalendarMonth',
        // role_access: ['TASK.USER'],
        children: [
          {
            id: 'app-agenda-gc',
            title: 'Agenda',
            messageId: 'Agenda',
            type: 'item',
            icon: 'CalendarMonth',
            url: '/apps/GroupCalendar',
            role_access: ['CALENDAR.USER'],
          },
          {
            id: 'app-agenda-kalender',
            title: 'Kalender Personal',
            messageId: 'Kalender Personal',
            type: 'item',
            icon: 'CalendarMonth',
            url: '/apps/kalender-personal',
          },
          {
            id: 'app-agenda-kalender-satker',
            title: 'Kalender Satker',
            messageId: 'Kalender Satker',
            type: 'item',
            icon: 'CalendarMonth',
            url: '/apps/kalender-satker',
            role_access: ['CALENDAR_SATKER']
          },
        ],
      },
      // {
      //   id: 'app-kepegawaian',
      //   title: 'Kepegawaian',
      //   messageId: 'Kepegawaian',
      //   type: 'collapse',
      //   icon: 'LocalLibrary',
      //   children: [
      //     {
      //       id: 'app-kepegawaian-ipasn',
      //       title: 'IPASN',
      //       messageId: 'IPASN',
      //       type: 'item',
      //       icon: 'LocalLibrary',
      //       url: '/apps/kepegawaian/ipasn',
      //     },
      //     {
      //       id: 'app-kepegawaian-pegawai',
      //       title: 'Pegawai',
      //       messageId: 'Pegawai',
      //       type: 'item',
      //       icon: 'LocalLibrary',
      //       url: '/apps/kepegawaian/karyawan',
      //     },
      //     {
      //       id: 'app-kepegawaian-nominatif-pegawai',
      //       title: 'Nominatif Pegawai',
      //       messageId: 'Nominatif Pegawai',
      //       type: 'item',
      //       icon: 'LocalLibrary',
      //       url: '/apps/kepegawaian/nominatif-pegawai',
      //     },
      //     {
      //       id: 'app-sispeg',
      //       title: 'SIPEG',
      //       messageId: 'SIPEG',
      //       type: 'item',
      //       isNewWindow: '1',
      //       icon: 'LocalLibrary',
      //       url: AppsURL['17'],
      //       role_access: ['A0001']
      //     },
      //   ],
      // },
      {
        id: 'app-event',
        title: 'Event Management',
        messageId: 'Event Management',
        type: 'item',
        isIframe: '1',
        icon: 'EventAvailable',
        url: '/apps/event',
        role_access: ['EVENT.USER'],
      },
      {
        id: 'app-task',
        title: 'Task Management',
        messageId: 'Task Management',
        type: 'collapse',
        icon: 'TaskAlt',
        // role_access: ['TASK.USER'],
        children: [
          {
            id: 'main-app-task',
            title: 'Main',
            messageId: 'Main',
            type: 'item',
            icon: 'TaskAlt',
            url: '/apps/taskmanagement',
          },
          {
            id: 'app-task-rangkuman',
            title: 'Laporan',
            messageId: 'Laporan',
            type: 'item',
            icon: 'TaskAlt',
            url: '/dash/tab/taskmanagement',
          },
        ],
      },
      // {
      //   id: 'app-drive',
      //   title: 'Drive',
      //   messageId: 'Drive',
      //   type: 'item',
      //   icon: 'DriveFileMove',
      //   url: '/apps/drive',
      //   // role_access: [],
      // },
      {
        id: 'app-repository',
        title: 'Repositori',
        messageId: 'Repositori',
        type: 'item',
        isNewWindow: '1',
        icon: 'DriveFileMove',
        url: AppsURL['13'],
        // role_access: [],
      },
      {
        id: 'app-rtc',
        title: 'Real Time Collaboration',
        messageId: 'Real Time Collaboration',
        type: 'collapse',
        icon: 'Groups',
        // role_access: [],
        children: [
          {
            id: 'chat',
            title: 'Chat',
            messageId: 'Chat',
            type: 'item',
            isNewWindow: '1',
            icon: 'Groups',
            url: AppsURL['11'],
            // role_access: [],
          },
          {
            id: 'app-videconf',
            title: 'Video Conference',
            messageId: 'Video Conference',
            type: 'item',
            isNewWindow: '1',
            icon: 'VideoCall',
            url: AppsURL['9'],
            // role_access: [],
          },
        ],
      },
      {
        id: 'app-helpdesk',
        title: 'Help Desk',
        messageId: 'Help Desk',
        type: 'item',
        isNewWindow: '1',
        icon: 'HelpCenter',
        url: AppsURL['12'],
      },
    ],
  },
  {
    id: 'app-bankom',
    title: 'Pengembangan Kompetensi',
    messageId: 'Pengembangan Kompetensi',
    type: 'group',
    children: [
      {
        id: 'mp',
        title: 'Manajemen Pengetahuan',
        messageId: 'Pengetahuan',
        type: 'collapse',
        icon: 'School',
        children: [
          {
            id: 'mp-linimasa',
            title: 'Manajemen Pengetahuan',
            messageId: 'Lini Masa',
            type: 'item',
            isIframe: '1',
            icon: 'School',
            url: '/apps/KnowledgeManagement',
          },
          {
            id: 'mp-postingan_saya',
            title: 'Postingan Saya',
            messageId: 'Postingan Saya',
            type: 'item',
            icon: 'School',
            url: '/apps/mypost',
          },
          {
            id: 'mp-admin-dashrangiku',
            title: 'Rangkuman IKU',
            messageId: 'Rangkuman IKU',
            type: 'item',
            icon: 'School',
            url: '/new-dash/tab/rangkuman-iku',
            role_access: [
              'MP.PNL',
              'PNL.SES.BKIPMKHP',
              'PNL.SES.BRSDM',
              'PNL.SES.DJPB',
              'PNL.SES.DJPDSPKP',
              'PNL.SES.DJPRL',
              'PNL.SES.DJPSDKP',
              'PNL.SES.DJPT',
              'PNL.SES.IJ',
              'PNL.SES.PSD',
              'PNL.SES.SEKJEN',
            ],
          },
          {
            id: 'mp-admin-laporan',
            title: 'Laporan',
            messageId: 'Laporan',
            type: 'item',
            icon: 'School',
            url: '/apps/adminkm-laporan',
            role_access: [
              'MP.PNL',
              'PNL.SES.BKIPMKHP',
              'PNL.SES.BRSDM',
              'PNL.SES.DJPB',
              'PNL.SES.DJPDSPKP',
              'PNL.SES.DJPRL',
              'PNL.SES.DJPSDKP',
              'PNL.SES.DJPT',
              'PNL.SES.IJ',
              'PNL.SES.PSD',
              'PNL.SES.SEKJEN',
            ],
          },
          {
            id: 'mp-admin-penilaian',
            title: 'Penilaian',
            messageId: 'Penilaian',
            type: 'item',
            icon: 'School',
            url: '/apps/adminkm-penilaian',
            role_access: [
              'MP.PNL',
              'PNL.SES.BKIPMKHP',
              'PNL.SES.BRSDM',
              'PNL.SES.DJPB',
              'PNL.SES.DJPDSPKP',
              'PNL.SES.DJPRL',
              'PNL.SES.DJPSDKP',
              'PNL.SES.DJPT',
              'PNL.SES.IJ',
              'PNL.SES.PSD',
              'PNL.SES.SEKJEN',
            ],
          },
          // {
          //   id: 'mp-admin-kategori',
          //   title: 'Kategori',
          //   messageId: 'Kategori',
          //   type: 'item',
          //   icon: 'School',
          //   url: '/apps/adminkm-kategori',
          // },
          // {
          //   id: 'mp-admin-kompetensi',
          //   title: 'Kompetensi',
          //   messageId: 'Kompetensi',
          //   type: 'item',
          //   icon: 'School',
          //   url: '/apps/adminkm-kompetensi',
          // },
        ],
      },
      {
        id: 'app-aksi-perubahan',
        title: 'Aksi Perubahan',
        messageId: 'Aksi Perubahan',
        type: 'item',
        icon: 'PublishedWithChanges',
        url: '/apps/information/aksi-perubahan',
      },
      {
        id: 'app-sertifikat',
        title: 'Sertifikat',
        messageId: 'Sertifikat',
        type: 'collapse',
        icon: 'Villa',
        children: [
          {
            id: 'app-sertifikat-lms',
            title: 'Sertifikat LMS',
            messageId: 'Sertifikat LMS',
            type: 'item',
            icon: 'Villa',
            url: '/apps/sertifikat-lms',
          },
          {
            id: 'app-sertifikat-ttde',
            title: 'Sertifikat TTDE',
            messageId: 'Sertifikat TTDE',
            type: 'item',
            icon: 'Villa',
            url: '/apps/sertifikat-ttde',
          },
          {
            id: 'app-sertifikat-eksternal',
            title: 'Sertifikat Eksternal',
            messageId: 'Sertifikat Eksternal',
            type: 'item',
            icon: 'Villa',
            url: '/apps/sertifikat-eksternal',
          },
        ],
      },
      {
        id: 'app-bankom-laporan',
        title: 'Laporan',
        messageId: 'Laporan',
        type: 'item',
        icon: 'Create',
        url: '/apps/laporan-bankom',
        role_access: ['LAPORAN_BSRE', 'MONITORING_DIGITAL_SIGN'],
      },
      {
        id: 'app-elearning',
        title: 'e-Learning',
        messageId: 'e-Learning',
        type: 'item',
        isNewWindow: '1',
        icon: 'LocalLibrary',
        url: AppsURL['15'],
      },
      // {
      //   id: 'info-modal',
      //   title: 'Info',
      //   messageId: 'Info',
      //   type: 'modal',
      //   icon: 'InfoOutlined'
      // }
    ]
  },
  {
    id: 'app-perizinan-menteri',
    title: 'Perizinan Menteri',
    messageId: 'Perizinan Menteri',
    type: 'nonGroup',
    icon: 'Gesture',
    role_access: ['PERIZINAN_MENTERI', 'MONITORING_DIGITAL_SIGN'],
    url: '/apps/perizinan-menteri/pkrl',
  },
  {
    id: 'app-sertifikat-menteri',
    title: 'Sertifikat Menteri',
    messageId: 'Sertifikat Menteri',
    type: 'nonGroup',
    icon: 'WorkspacePremium',
    role_access: ['SERTIFIKAT_MENTERI', 'MONITORING_DIGITAL_SIGN'],
    url: '/apps/sertifikat-menteri',
  },
  {
    id: 'app-produk-hukum',
    title: 'Produk Hukum',
    messageId: 'Produk Hukum',
    type: 'group',
    role_access: ['UPLOAD.PRODUK.HUKUM', 'UPLOAD.PRODUK.HUKUM.DIRJEN', 'OPERATOR.NOMOR.PRODUK.HUKUM', 'MONITORING_DIGITAL_SIGN', 'APPROVERS.PRODUK.HUKUM.DIRJEN'],
    children: [
      {
        id: 'app-produk-hukum-biro-hukum',
        title: 'Produk Hukum Biro Hukum',
        messageId: 'Produk Hukum Biro Hukum',
        type: 'item',
        icon: 'AssignmentTurnedIn',
        url: '/apps/produk-hukum',
        role_access: ['UPLOAD.PRODUK.HUKUM', 'OPERATOR.NOMOR.PRODUK.HUKUM', 'MONITORING_DIGITAL_SIGN'],
      },
      {
        id: 'app-produk-hukum-dirjen',
        title: 'Produk Hukum Dirjen',
        messageId: 'Produk Hukum Dirjen',
        type: 'item',
        icon: 'AssignmentTurnedIn',
        url: '/apps/produk-hukum-dirjen',
        role_access: ['UPLOAD.PRODUK.HUKUM.DIRJEN', 'MONITORING_DIGITAL_SIGN', 'APPROVERS.PRODUK.HUKUM.DIRJEN'],
      },
    ]
  },
  {
    id: 'produk-lpmukp',
    title: 'Produk LPMUKP',
    messageId: 'Produk LPMUKP',
    role_access: ['PRODUK.LPMUKP'],
    type: 'nonGroup',
    icon: 'Assignment',
    url: '/produk-lpmukp',
  },
  {
    id: 'monitoring-program-kerja',
    title: 'Monitoring Program Kerja',
    messageId: 'Monitoring Program Kerja',
    type: 'nonGroup',
    icon: 'Timeline',
    url: '/program-kerja',
    role_access: ['PENGISIAN_PROGRAM_KERJA', 'MONITORING_PROGRAM_KERJA_ESELON_ALL', 'MONITORING_PROGRAM_KERJA_ESELON_1'],
  },
  {
    id: 'admtls',
    title: 'Admintools',
    messageId: 'Admin Tools',
    role_access: ['ADMIN_TOOLS'],
    type: 'group',
    children: [
      {
        id: 'admtls-profile',
        title: 'Profile',
        messageId: 'Profile',
        type: 'collapse',
        icon: 'SupervisorAccount',
        role_access: ['ADMIN_TOOLS'],
        children: [
          {
            id: 'admtls-pegawai',
            title: 'Pegawai',
            messageId: 'Pegawai',
            type: 'item',
            icon: 'SupervisorAccount',
            url: '/apps/admintools/employee',
          },

          {
            id: 'admtls-jabatan',
            title: 'Jabatan',
            messageId: 'Jabatan',
            type: 'item',
            icon: 'SupervisorAccount',
            url: '/apps/admintools/title',
          },
          {
            id: 'admtls-struktur-organisasi',
            title: 'Struktur Organisasi',
            messageId: 'Struktur Organisasi',
            type: 'item',
            icon: 'SupervisorAccount',
            url: '/apps/admintools/division',
          },
          // {
          //   id: 'admtls-user-role',
          //   title: 'User Role',
          //   messageId: 'User Role',
          //   type: 'item',
          //   url: '/apps/admintools/user-role',
          // },
          {
            id: 'app-userrole',
            title: 'User Role',
            messageId: 'User Role',
            type: 'item',
            icon: 'SupervisorAccount',
            url: '/apps/userrole',
          },
        ],
      },
      {
        id: 'admtls-pengetahuan',
        title: 'Pengetahuan',
        messageId: 'Pengetahuan',
        type: 'collapse',
        icon: 'School',
        role_access: ['ADMIN_TOOLS'],
        children: [
          {
            id: 'admtls-admin-kompetensi',
            title: 'Kompetensi',
            messageId: 'Kompetensi',
            type: 'item',
            icon: 'School',
            url: '/apps/adminkm-kompetensi',
          },
          {
            id: 'admtls-admin-kategori',
            title: 'Kategori',
            messageId: 'Kategori',
            type: 'item',
            icon: 'School',
            url: '/apps/adminkm-kategori',
          },
        ],
      },

      {
        id: 'admtls-crsfe',
        title: 'Korespondensi',
        messageId: 'Korespondensi',
        type: 'collapse',
        icon: 'InsertDriveFile',
        role_access: ['CRSFE_ADMIN_PENOMORAN'],
        children: [
          {
            id: 'admtls-penomoran',
            title: 'Penomoran',
            messageId: 'Penomoran',
            type: 'item',
            icon: 'InsertDriveFile',
            url: '/apps/admintools/penomoran',
            // role_access: []
          },
          // {
          //   id: 'admtls-nomor-akhir-elayar',
          //   title: 'Nomor Terakhir E-Layar',
          //   messageId: 'Nomor Terakhir E-Layar',
          //   type: 'item',
          //   icon: 'InsertDriveFile',
          //   url: '/apps/admintools/no-elayar',
          //   // role_access: []
          // },
          {
            id: 'admtls-scan',
            title: 'Input Surat Masuk',
            messageId: 'Input Surat Masuk',
            type: 'item',
            icon: 'InsertDriveFile',
            url: '/apps/admintools/input-scan',
            // role_access: []
          },
          {
            id: 'admtls-inpusurat',
            title: 'Input Surat Keluar',
            messageId: 'Input Surat Keluar',
            type: 'item',
            icon: 'InsertDriveFile',
            url: '/apps/admintools/input-sk',
            // role_access: []
          },
          {
            id: 'admtls-addgroup',
            title: 'Group Addressbook',
            messageId: 'Group Addressbook',
            type: 'item',
            icon: 'InsertDriveFile',
            url: '/apps/admintools/group-book',
            // role_access: []
          },
          {
            id: 'admtls-operator',
            title: 'Operator',
            messageId: 'Operator',
            type: 'item',
            icon: 'InsertDriveFile',
            url: '/apps/admintools/operator',
            role_access: [],
          },
        ],
      },
      {
        id: 'admtls-masterdata',
        title: 'Master Data',
        messageId: 'Master Data',
        role_access: ['ADMIN_TOOLS'],
        type: 'collapse',
        icon: 'Storage',
        children: [
          // {
          //   id: 'admntls-organisasi',
          //   title: 'Organisasi',
          //   messageId: 'Organisasi',
          //   type: 'item',
          //   icon: 'Storage',
          //   url: '/apps/admintools/organisasi',
          //   // role_access: []
          // },
          {
            id: 'admntls-satker',
            title: 'Unit Kerja',
            messageId: 'Unit Kerja',
            type: 'item',
            icon: 'Storage',
            url: '/apps/admintools/satker',
            // role_access: []
          },

          {
            id: 'admntls-unitkerja',
            title: 'Satuan Kerja',
            messageId: 'Satuan Kerja',
            type: 'item',
            icon: 'Storage',
            url: '/apps/admintools/unitkerja',
            // role_access: []
          },
          {
            id: 'admntls-km',
            title: 'Kode Retensi',
            messageId: 'Kode Retensi',
            type: 'item',
            icon: 'Storage',
            url: '/apps/admintools/km',
            // role_access: []
          },
          {
            id: 'admntls-jobs',
            title: 'Jobs',
            messageId: 'Jobs',
            type: 'item',
            icon: 'Storage',
            url: '/apps/admintools/jobs',
            // role_access: []
          },
          {
            id: 'admntls-notatindakan',
            title: 'Nota Tindakan',
            messageId: 'Nota Tindakan',
            type: 'item',
            icon: 'Storage',
            url: '/apps/admintools/notatindakan',
            // role_access: []
          },
          {
            id: 'admtls-faq',
            title: 'FAQ DATA',
            messageId: 'FAQ DATA',
            type: 'collapse',
            icon: 'Storage',
            children: [
              {
                id: 'admtls-faq',
                title: 'FAQ ',
                messageId: 'FAQ ',
                type: 'item',
                url: '/apps/admintools/faq',
                icon: 'Storage',
              },
              {
                id: 'admtls-faq-module',
                title: 'FAQ MODUL',
                messageId: 'FAQ MODUL ',
                type: 'item',
                url: '/apps/admintools/module',
                icon: 'Storage',
              },
              {
                id: 'admtls-faq-group',
                title: 'FAQ GROUP',
                messageId: 'FAQ GROUP ',
                type: 'item',
                url: '/apps/admintools/group',
                icon: 'Storage',
              },
            ],
          },
          // {
          //   id: 'admntls-bidang',
          //   title: 'Bidang',
          //   messageId: 'Bidang',
          //   type: 'item',
          //   icon: 'Storage',
          //   url: '/apps/admintools/bidang',
          //   // role_access: []
          // },
          // {
          //   id: 'admntls-subbidang',
          //   title: 'Sub Bidang',
          //   messageId: 'Sub Bidang',
          //   type: 'item',
          //   icon: 'Storage',
          //   url: '/apps/admintools/subbidang',
          //   // role_access: []
          // },
          // {
          //   id: 'admntls-retensi',
          //   title: 'Kode Retensi',
          //   messageId: 'Kode Retensi',
          //   type: 'item',
          //   icon: 'Storage',
          //   url: '/apps/admintools/retensi',
          //   // role_access: []
          // },
        ],
      },
      {
        id: 'admtls-logs',
        title: 'Logs',
        messageId: 'Logs',
        role_access: ['ADMIN_TOOLS'],
        type: 'collapse',
        icon: 'MonitorHeart',
        children: [
          {
            id: 'admntls-logs',
            title: 'Log Login',
            messageId: 'Log Login',
            type: 'item',
            icon: 'MonitorHeart',
            url: '/apps/admintools/logs',
            role_access: ['ADMIN_TOOLS'],
          },
          {
            id: 'admntls-logs-notification',
            title: 'Log Notification',
            messageId: 'Log Notification',
            type: 'item',
            icon: 'MonitorHeart',
            url: '/apps/admintools/logsnotification',
            role_access: ['ADMIN_TOOLS'],
          },
          {
            id: 'admntls-logs-download',
            title: 'Log Download',
            messageId: 'Log Download',
            type: 'item',
            icon: 'MonitorHeart',
            url: '/apps/admintools/logsheaven',
            role_access: ['ADMIN_TOOLS'],
          },
          {
            id: 'admntls-logs-print',
            title: 'Log Print',
            messageId: 'Log Print',
            type: 'item',
            icon: 'MonitorHeart',
            url: '/apps/admintools/logsprint',
            role_access: ['ADMIN_TOOLS'],
          },
          {
            id: 'admntls-logs-service-digisign',
            title: 'Log Service Digital Sign',
            messageId: 'Log Service Digital Sign',
            type: 'item',
            icon: 'MonitorHeart',
            url: '/apps/admintools/logsservicedigisign',
            role_access: ['ADMIN_TOOLS'],
          },
        ],
      },

      {
        id: 'admntls-template',
        title: 'Template',
        messageId: 'Template',
        type: 'item',
        icon: 'FileCopy',
        url: '/apps/admintools/template',
        role_access: ['ADMIN_TOOLS'],
      },
      // {
      //   id: 'admtls-digisign',
      //   title: 'Tanda Tangan Digital',
      //   messageId: 'Tanda Tangan Digital',
      //   role_access: ['ADMIN_TOOLS'],
      //   type: 'collapse',
      //   icon: <Edit sx={{ fontSize: '20px' }} />,
      //   children: [

      //     {
      //       id: 'admntls-report',
      //       title: 'Report',
      //       messageId: 'Report',
      //       type: 'item',
      //       icon: <Edit sx={{ fontSize: '20px' }} />,
      //       url: '/apps/admintools/detail/report-admtls',
      //       // role_access: []
      //     },

      //     {
      //       id: 'admtls-course',
      //       title: 'Judul Course',
      //       messageId: 'Judul Course',
      //       type: 'item',
      //       icon: <Edit sx={{ fontSize: '20px' }} />,
      //       url: '/apps/admintools/course',
      //       // role_access: []
      //     },
      //     {
      //       id: 'admtls-penandatanganan',
      //       title: 'Penandatanganan Bankom',
      //       messageId: 'Penandatanganan Bankom',
      //       type: 'item',
      //       icon: <Edit sx={{ fontSize: '20px' }} />,
      //       url: '/apps/admintools/signer',
      //       // role_access: []
      //     },
      //     {
      //       id: 'admtls-tipedokumen',
      //       title: 'Tipe Document',
      //       messageId: 'Tipe Document',
      //       type: 'item',
      //       icon: <Edit sx={{ fontSize: '20px' }} />,
      //       url: '/apps/admintools/type-document',
      //       // role_access: []
      //     },

      //   ]
      // },
    ],
  },
  {
    id: 'app-group-cms',
    title: 'CMS',
    messageId: 'CMS',
    type: 'group',
    role_access: ['OP.UNKER.WEB', 'ADMIN.UNKER.WEB', 'ADMIN.WEB', 'PPID.KKP', 'PPID.P.PUSAT', 'PPID.P.TEKNIS', 'WEB.UKPBJ', 'WEB.ROPEG'],
    children: [
      {
        id: 'app-cms',
        title: 'CMS_Website',
        messageId: 'Website',
        type: 'item',
        isNewWindow: '1',
        icon: 'Language',
        url: 'https://website.kubekkp.coofis.com/oidc/authenticate',
        role_access: ['OP.UNKER.WEB', 'ADMIN.UNKER.WEB', 'ADMIN.WEB'],
      },
      {
        id: 'app-ppid',
        title: 'CMS_PPID',
        messageId: 'PPID',
        type: 'item',
        isNewWindow: '1',
        icon: 'Language',
        url: 'https://ppid-python.kubekkp.coofis.com/manage/oidc/authenticate/',
        role_access: ['PPID.KKP', 'PPID.P.PUSAT', 'PPID.P.TEKNIS'],
      },
      {
        id: 'app-ukpbj',
        title: 'CMS_UKPBJ',
        messageId: 'UKPBJ',
        type: 'item',
        isNewWindow: '1',
        icon: 'Language',
        url: 'https://portal.kubekkp.coofis.com/',
        role_access: ['WEB.UKPBJ'],
      },
      {
        id: 'app-sdmao',
        title: 'CMS_SDMAO',
        messageId: 'SDMAO',
        type: 'item',
        isNewWindow: '1',
        icon: 'Language',
        url: 'https://ropeg.kubekkp.coofis.com/back-office/oidc/authenticate/',
        role_access: ['WEB.ROPEG'],
      },
    ]
  },
  {
    id: 'app-survey',
    title: 'Survei',
    messageId: 'Survei Layanan',
    type: 'nonGroup',
    icon: 'DriveFileRenameOutline',
    url: '/survey',
  },
  // {
  //   id: 'app-kehadiran',
  //   title: 'Kehadiran',
  //   messageId: 'Kehadiran',
  //   type: 'nonGroup',
  //   icon: 'CoPresentOutlined',
  //   url: '/kehadiran',
  //   permitted_role: ['honorer'],
  // },
];

// export const routeConfigAdmintools = [
//   {
//     id: 'main',
//     title: 'Halaman Utama',
//     messageId: 'Halaman Utama',
//     type: 'group',
//     children: [
//       {
//         id: 'main-kkp',
//         title: 'KKP',
//         messageId: 'KKP',
//         type: 'item',
//         icon: 'Home',
//         url: '/kkp',
//       },
//       {
//         id: 'main-satker',
//         title: 'Satuan Kerja',
//         messageId: 'Satker',
//         type: 'item',
//         icon: 'Villa',
//         url: '/satker',
//       },
//     ],
//   },
//   {
//     id: 'admtls',
//     title: 'Admintools',
//     messageId: 'Admin Tools',
//     type: 'group',
//     children: [
//       {
//         id: 'admtls-profile',
//         title: 'Profile',
//         messageId: 'Profile',
//         type: 'collapse',
//         icon: 'SupervisorAccount',
//         role_access: ['ADMIN_TOOLS'],
//         children: [
//           {
//             id: 'admtls-pegawai',
//             title: 'Pegawai',
//             messageId: 'Pegawai',
//             type: 'item',
//             icon: 'SupervisorAccount',
//             url: '/apps/admintools/employee',
//           },

//           {
//             id: 'admtls-jabatan',
//             title: 'Jabatan',
//             messageId: 'Jabatan',
//             type: 'item',
//             icon: 'SupervisorAccount',
//             url: '/apps/admintools/title',
//           },
//           {
//             id: 'admtls-struktur-organisasi',
//             title: 'Struktur Organisasi',
//             messageId: 'Struktur Organisasi',
//             type: 'item',
//             icon: 'SupervisorAccount',
//             url: '/apps/admintools/division',
//           },
//           // {
//           //   id: 'admtls-user-role',
//           //   title: 'User Role',
//           //   messageId: 'User Role',
//           //   type: 'item',
//           //   url: '/apps/admintools/user-role',
//           // },
//           {
//             id: 'app-userrole',
//             title: 'User Role',
//             messageId: 'User Role',
//             type: 'item',
//             icon: 'SupervisorAccount',
//             url: '/apps/userrole',
//           },
//         ],
//       },
//       {
//         id: 'admtls-pengetahuan',
//         title: 'Pengetahuan',
//         messageId: 'Pengetahuan',
//         type: 'collapse',
//         icon: 'School',
//         role_access: ['ADMIN_TOOLS'],
//         children: [
//           {
//             id: 'admtls-admin-kompetensi',
//             title: 'Kompetensi',
//             messageId: 'Kompetensi',
//             type: 'item',
//             icon: 'School',
//             url: '/apps/adminkm-kompetensi',
//           },
//           {
//             id: 'admtls-admin-kategori',
//             title: 'Kategori',
//             messageId: 'Kategori',
//             type: 'item',
//             icon: 'School',
//             url: '/apps/adminkm-kategori',
//           },
//         ],
//       },

//       {
//         id: 'admtls-crsfe',
//         title: 'Korespondensi',
//         messageId: 'Korespondensi',
//         type: 'collapse',
//         icon: 'InsertDriveFile',
//         role_access: ['CRSFE_ADMIN_PENOMORAN'],
//         children: [
//           {
//             id: 'admtls-penomoran',
//             title: 'Penomoran',
//             messageId: 'Penomoran',
//             type: 'item',
//             icon: 'InsertDriveFile',
//             url: '/apps/admintools/penomoran',
//             // role_access: []
//           },
//           {
//             id: 'admtls-nomor-akhir-elayar',
//             title: 'Nomor Terakhir E-Layar',
//             messageId: 'Nomor Terakhir E-Layar',
//             type: 'item',
//             icon: 'InsertDriveFile',
//             url: '/apps/admintools/no-elayar',
//             // role_access: []
//           },
//           {
//             id: 'admtls-scan',
//             title: 'Input Surat Masuk',
//             messageId: 'Input Surat Masuk',
//             type: 'item',
//             icon: 'InsertDriveFile',
//             url: '/apps/admintools/input-scan',
//             // role_access: []
//           },
//           {
//             id: 'admtls-inpusurat',
//             title: 'Input Surat Keluar',
//             messageId: 'Input Surat Keluar',
//             type: 'item',
//             icon: 'InsertDriveFile',
//             url: '/apps/admintools/input-sk',
//             // role_access: []
//           },
//           {
//             id: 'admtls-operator',
//             title: 'Operator',
//             messageId: 'Operator',
//             type: 'item',
//             icon: 'InsertDriveFile',
//             url: '/apps/admintools/operator',
//             role_access: [],
//           },

//         ],
//       },
//       {
//         id: 'admtls-masterdata',
//         title: 'Master Data',
//         messageId: 'Master Data',
//         role_access: ['ADMIN_TOOLS'],
//         type: 'collapse',
//         icon: 'Storage',
//         children: [
//           // {
//           //   id: 'admntls-organisasi',
//           //   title: 'Organisasi',
//           //   messageId: 'Organisasi',
//           //   type: 'item',
//           //   icon: 'Storage',
//           //   url: '/apps/admintools/organisasi',
//           //   // role_access: []
//           // },
//           {
//             id: 'admntls-satker',
//             title: 'Unit Kerja',
//             messageId: 'Unit Kerja',
//             type: 'item',
//             icon: 'Storage',
//             url: '/apps/admintools/satker',
//             // role_access: []
//           },
//           {
//             id: 'admntls-unitkerja',
//             title: 'Satuan Kerja',
//             messageId: 'Satuan Kerja',
//             type: 'item',
//             icon: 'Storage',
//             url: '/apps/admintools/unitkerja',
//             // role_access: []
//           },
//           {
//             id: 'admntls-km',
//             title: 'Kode Retensi',
//             messageId: 'Kode Retensi',
//             type: 'item',
//             icon: 'Storage',
//             url: '/apps/admintools/km',
//             // role_access: []
//           },
//           {
//             id: 'admntls-jobs',
//             title: 'Jobs',
//             messageId: 'Jobs',
//             type: 'item',
//             icon: 'Storage',
//             url: '/apps/admintools/jobs',
//             // role_access: []
//           },
//           {
//             id: 'admntls-notatindakan',
//             title: 'Nota Tindakan',
//             messageId: 'Nota Tindakan',
//             type: 'item',
//             icon: 'Storage',
//             url: '/apps/admintools/notatindakan',
//             // role_access: []
//           },
//           // {
//           //   id: 'admntls-bidang',
//           //   title: 'Bidang',
//           //   messageId: 'Bidang',
//           //   type: 'item',
//           //   icon: 'Storage',
//           //   url: '/apps/admintools/bidang',
//           //   // role_access: []
//           // },
//           // {
//           //   id: 'admntls-subbidang',
//           //   title: 'Sub Bidang',
//           //   messageId: 'Sub Bidang',
//           //   type: 'item',
//           //   icon: 'Storage',
//           //   url: '/apps/admintools/subbidang',
//           //   // role_access: []
//           // },
//           // {
//           //   id: 'admntls-retensi',
//           //   title: 'Kode Retensi',
//           //   messageId: 'Kode Retensi',
//           //   type: 'item',
//           //   icon: 'Storage',
//           //   url: '/apps/admintools/retensi',
//           //   // role_access: []
//           // },
//         ],
//       },
//       {
//         id: 'admtls-logs-masterdata',
//         title: 'Logs',
//         messageId: 'Logs',
//         role_access: ['ADMIN_TOOLS'],
//         type: 'collapse',
//         icon: 'MonitorHeart',
//         children: [
//           {
//             id: 'admntls-logs',
//             title: 'Log Login',
//             messageId: 'Log Login',
//             type: 'item',
//             icon: 'MonitorHeart',
//             url: '/apps/admintools/logs',
//             role_access: ['ADMIN_TOOLS']
//           },
//           {
//             id: 'admntls-logs-download',
//             title: 'Log Download',
//             messageId: 'Log Download',
//             type: 'item',
//             icon: 'MonitorHeart',
//             url: '/apps/admintools/logsheaven',
//             role_access: ['ADMIN_TOOLS']
//           },
//           {
//             id: 'admntls-logs-print',
//             title: 'Log Print',
//             messageId: 'Log Print',
//             type: 'item',
//             icon: 'MonitorHeart',
//             url: '/apps/admintools/logsprint',
//             role_access: ['ADMIN_TOOLS']
//           },
//         ]
//       },

//       {
//         id: 'admntls-template',
//         title: 'Template',
//         messageId: 'Template',
//         type: 'item',
//         icon: 'FileCopy',
//         url: '/apps/admintools/template',
//         role_access: ['ADMIN_TOOLS']
//       },
//       // {
//       //   id: 'admtls-digisign',
//       //   title: 'Tanda Tangan Digital',
//       //   messageId: 'Tanda Tangan Digital',
//       //   role_access: ['ADMIN_TOOLS'],
//       //   type: 'collapse',
//       //   icon: <Edit sx={{ fontSize: '20px' }} />,
//       //   children: [

//       //     {
//       //       id: 'admntls-report',
//       //       title: 'Report',
//       //       messageId: 'Report',
//       //       type: 'item',
//       //       icon: <Edit sx={{ fontSize: '20px' }} />,
//       //       url: '/apps/admintools/detail/report-admtls',
//       //       // role_access: []
//       //     },

//       //     {
//       //       id: 'admtls-course',
//       //       title: 'Judul Course',
//       //       messageId: 'Judul Course',
//       //       type: 'item',
//       //       icon: <Edit sx={{ fontSize: '20px' }} />,
//       //       url: '/apps/admintools/course',
//       //       // role_access: []
//       //     },
//       //     {
//       //       id: 'admtls-penandatanganan',
//       //       title: 'Penandatanganan Bankom',
//       //       messageId: 'Penandatanganan Bankom',
//       //       type: 'item',
//       //       icon: <Edit sx={{ fontSize: '20px' }} />,
//       //       url: '/apps/admintools/signer',
//       //       // role_access: []
//       //     },
//       //     {
//       //       id: 'admtls-tipedokumen',
//       //       title: 'Tipe Document',
//       //       messageId: 'Tipe Document',
//       //       type: 'item',
//       //       icon: <Edit sx={{ fontSize: '20px' }} />,
//       //       url: '/apps/admintools/type-document',
//       //       // role_access: []
//       //     },

//       //   ]
//       // },
//       {
//         id: 'app-portal',
//         title: 'Portal',
//         messageId: 'Portal ',
//         type: 'item',
//         icon: <ArrowBack sx={{ fontSize: '20px' }} />,
//         isAction: '1',
//       },
//     ],
//   },
// ];

export const routeConfigAdmintools = [
  {
    id: 'admtls-crsfe',
    title: 'Korespondensi',
    messageId: 'Korespondensi',
    role_access: ['CRSFE_ADMIN_PENOMORAN'],
    type: 'group',
    children: [
      {
        id: 'admtls-penomoran',
        title: 'Penomoran',
        messageId: 'Penomoran',
        type: 'item',
        icon: 'InsertDriveFile',
        url: '/apps/admintools/penomoran',
        // role_access: []
      },
      // {
      //   id: 'admtls-nomor-akhir-elayar',
      //   title: 'Nomor Terakhir E-Layar',
      //   messageId: 'Nomor Terakhir E-Layar',
      //   type: 'item',
      //   icon: 'InsertDriveFile',
      //   url: '/apps/admintools/no-elayar',
      //   // role_access: []
      // },
      {
        id: 'admtls-scan',
        title: 'Input Surat Masuk',
        messageId: 'Input Surat Masuk',
        type: 'item',
        icon: 'InsertDriveFile',
        url: '/apps/admintools/input-scan',
        // role_access: []
      },
      {
        id: 'admtls-inpusurat',
        title: 'Input Surat Keluar',
        messageId: 'Input Surat Keluar',
        type: 'item',
        icon: 'InsertDriveFile',
        url: '/apps/admintools/input-sk',
        // role_access: []
      },
      {
        id: 'admtls-addgroup',
        title: 'Group Addressbook',
        messageId: 'Group Addressbook',
        type: 'item',
        icon: 'InsertDriveFile',
        url: '/apps/admintools/group-book',
        // role_access: []
      },
      {
        id: 'admtls-hasil-export',
        title: 'List Hasil Export',
        messageId: 'List Hasil Export',
        type: 'item',
        icon: 'InsertDriveFile',
        url: '/apps/admintools/hasil-export',
        role_access: []
      },
      {
        id: 'admtls-kop-surat',
        title: 'Kop Surat',
        messageId: 'Kop Surat',
        type: 'item',
        icon: 'InsertDriveFile',
        url: '/apps/admintools/kop-surat',
        // role_access: []
      },
      {
        id: 'admtls-kop-nota',
        title: 'Kop Nota',
        messageId: 'Kop Nota',
        type: 'item',
        icon: 'InsertDriveFile',
        url: '/apps/admintools/kop-nota',
        // role_access: []
      },
      {
        id: 'admtls-operator',
        title: 'Operator',
        messageId: 'Operator',
        type: 'item',
        icon: 'InsertDriveFile',
        url: '/apps/admintools/operator',
        role_access: [],
      },
    ],
  },
  {
    id: 'digital-sign',
    title: 'Digital Sign',
    messageId: 'Digital Sign',
    type: 'group',
    children: [
      {
        id: 'digital-sign-dokumen',
        title: 'Dokumen Lain',
        messageId: 'Dokumen Lain',
        type: 'item',
        icon: 'Create',
        url: '/apps/dokumen-lain',
      },
      {
        id: 'digital-sign-verify',
        title: 'Verifikasi',
        messageId: 'Verifikasi',
        type: 'item',
        isNewWindow: '1',
        icon: 'Create',
        url: AppsURL['14'],
      },
    ],
  },
  {
    id: 'app-produk-hukum-biro-hukum',
    title: 'Produk Hukum Biro Hukum',
    messageId: 'Produk Hukum Biro Hukum',
    type: 'nonGroup',
    icon: 'AssignmentTurnedIn',
    url: '/apps/produk-hukum',
    role_access: ['UPLOAD.PRODUK.HUKUM', 'OPERATOR.NOMOR.PRODUK.HUKUM', 'MONITORING_DIGITAL_SIGN'],
  },
  {
    id: 'produk-lpmukp',
    title: 'Produk LPMUKP',
    messageId: 'Produk LPMUKP',
    role_access: ['PRODUK.LPMUKP'],
    type: 'nonGroup',
    icon: 'InsertDriveFile',
    url: '/produk-lpmukp',
  },
];

export const AdminPenilaianRoutesConfigs = [
  {
    id: 'mp-admin-laporan',
    title: 'Laporan',
    messageId: 'Laporan',
    type: 'item',
    icon: 'School',
    url: '/apps/adminkm-laporan',
  },
  {
    id: 'mp-admin-penilaian',
    title: 'Penilaian',
    messageId: 'Penilaian',
    type: 'item',
    icon: 'School',
    url: '/apps/adminkm-penilaian',
    role_state: 'PNL',
  },
];

export const routesConfigLite = [
  {
    id: 'main',
    title: 'Halaman Utama',
    messageId: 'Halaman Utama',
    type: 'group',
    children: [
      {
        id: 'main-kkp',
        title: 'KKP',
        messageId: 'KKP',
        type: 'item',
        icon: 'Home',
        url: '/kkp',
      },
      {
        id: 'main-satker',
        title: 'Satuan Kerja',
        messageId: 'Satker',
        type: 'item',
        icon: 'Villa',
        url: '/satker',
      },
    ],
  },
]

export const routesConfigBPKExternal = [
  {
    id: 'app-bpk-drive-external',
    title: 'BPK Drive',
    messageId: 'BPK Drive',
    type: 'nonGroup',
    icon: 'ReceiptLong',
    url: '/apps/bpk-drive',
    role_access: ['BPK_DRIVE_EXTERNAL', 'BPK_MONITORING'],
  },
]

let routesConfig = isProd === '1' ? routesConfigProd : routesConfigDev;

export default routesConfig
